// extracted by css-extract-rspack-plugin
export default {"FileInputText":"rVgQz"};